import * as r from 'ramda';
import * as ra from 'ramda-adjunct';
import { put, call, select } from 'redux-saga/effects';

import { Routes, BaseRoutes } from 'constants/routes';

import * as $app from 'modules/app';
import * as $auth from 'modules/auth';
import * as actions from '../actions';

const getInitialRoute = function* () {
  const isCurrentUserAdmin = yield select($auth.getIsCurrentUserAdmin);
  if (isCurrentUserAdmin) {
    return Routes.Dashboard;
  }

  const isCurrentUserHrManager = yield select($auth.getIsCurrentUserHrManager);
  if (isCurrentUserHrManager) {
    return Routes.Datasets;
  }

  const isCurrentUserModerator = yield select($auth.getIsCurrentUserModerator);
  const isCurrentUserArtist = yield select($auth.getIsCurrentUserArtist);
  if (isCurrentUserModerator || isCurrentUserArtist) {
    yield $app.awaitOnboardingUpdated();
    const isOnboardingCompleted = yield select($app.getIsOnboardingCompleted);
    return isOnboardingCompleted ? Routes.Arts.Base : Routes.Profile;
  }
};

const navigateToFirstAvailableRoute = function* () {
  const userRoles = yield select($auth.getCurrentUserRoles);
  if (r.isEmpty(userRoles)) {
    return;
  }

  const availableBaseRoutes = BaseRoutes.filter(({ availableForRoles }) =>
    ra.isNotEmpty(r.intersection(availableForRoles, userRoles ?? []))
  );
  const firstAvailableRoute = r.head(availableBaseRoutes);
  yield put(actions.navigate(firstAvailableRoute.path));
};

export const navigateToInitialRoute = function* () {
  const initialRoute = yield call(getInitialRoute);
  if (initialRoute) {
    yield put(actions.navigate(initialRoute));
    return;
  }

  yield call(navigateToFirstAvailableRoute);
};
